import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BounceLoader from "react-spinners/ClipLoader";
import RespondentFlowApi from "../services/respondentFlow.api";
import LoggerService from "../services/logger.service";
import useQueryParams from "../utils/query.params";
import { ERROR_ROUTE, PROFILING_ROUTE } from "../constants/routes.constants";
import { getVisiorData } from "../services/visitor.service";
import { useMediaQuery } from "@mui/material";
import UserMediaService from "../services/user-media.service";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import { useIPQSCheck } from "./IPQSFraudChecker";
import environment from "../environments/environment.json";
import ClipLoader from "react-spinners/ClipLoader";
import { sessionStore } from "../services/storage.service";
import { windowLocation, windowLocationRelayed } from "../services/redirect.service";

dayjs.extend(duration);
const Landing = () => {
  const { checkIPQS } = useIPQSCheck();
  const [Loader] = useState(true);
  const [paramActive, setParamActive] = useState(false);
  const [deviceType, setDeviceType] = useState(0);
  const IsMobile = useMediaQuery("(min-width:480px)");
  const IsTablet = useMediaQuery("(min-width:768px)");
  const isLaptopsAndLarger = useMediaQuery("(min-width:1200px)");
  const [beaconUrl, setBeaconUrl] = useState(null);
  
  // const [isIpQsCallI, setIsIpQsCall] = useState(false);
  const queryParams = useQueryParams(); // ✅ Hook called at the top
  const [params, setParams] = useState({});

  useEffect(() => {
    const temp = {};
    queryParams.forEach((value, key) => {
      temp[key] = value;
    });

    setParams(temp);

    if (Object.keys(temp).length > 0 && !paramActive) {
      setParamActive(true);
    }
  }, [queryParams]);

  useEffect(() => {
    if (isLaptopsAndLarger) {
      setDeviceType(1);
    } else if (IsTablet) {
      setDeviceType(3);
    } else if (IsMobile) {
      setDeviceType(2);
    } else {
      setDeviceType(2);
    }
  }, [IsTablet, isLaptopsAndLarger]);

  let navigate = useNavigate();
  useEffect(() => {
    if (params) {
      console.log("params", params);
      if (paramActive === false) setParamActive(true);
    } else {
      navigate(ERROR_ROUTE);
    }
    // eslint-disable-next-line
  }, [params]);

  let getStatus = async () => {
    let payload = { ...params };
    const useMedia = await UserMediaService.getUserAgents();
    const location = await UserMediaService.getLocation();

    payload.device_type = deviceType;
    payload.fp_data = getVisiorData();
    if (environment.IPQS_ENABLED === "true") {
      const ipqsResult = await checkIPQS(
        payload.vq_token,
        payload.vq_uid ?? "",
        payload.vq_vid,
        payload.vq_sid
      );
      payload.fp_data.ipqsVisitorId = ipqsResult?.device_id;
      if (ipqsResult?.cached == undefined || !ipqsResult?.cached) {
        payload.ipqsPayload = ipqsResult;
      }
    }

    payload.deviceType = deviceType; //TODO ASIF:: 1-Desktop, 2-Mobile, 3-Tablet
    payload.url = window.location.href;

    payload = { ...payload, ...useMedia, ...location };

    LoggerService.log(
      "",
      params.vq_token ?? "",
      "New Click received - " + payload.url
    );
    LoggerService.log(
      "",
      params.vq_token,
      "Calling landing register",
      JSON.stringify(payload)
    );
    try {
      let data = await RespondentFlowApi.post(`/v1/landing`, payload);
      LoggerService.log(
        data.token,
        data.vendorToken ?? "",
        "Click registered with token - " + data.token,
        JSON.stringify(data)
      );
      let obj = {};
      obj.paramList = data.paramList;
      obj.sessionUid = data.sessionUid;
      obj.surveyUid = data.surveyUid;
      obj.vendorUid = data.vendorUid;
      obj.token = data.token;
      obj.tokenId = data.tokenId;
      obj.userUid = data.userUid;
      obj.userId = data.userId;
      obj.traceId = data.traceId;
      obj.vendorToken = data.vendorToken;
      obj.rdEnable = data.rdEnable ?? false;

      sessionStore.removeItem("params");
      sessionStore.setItem("params", JSON.stringify(obj));
      if (data.runBeacon == true && data.beaconUrl !== null) {
        setBeaconUrl(data.beaconUrl);
        LoggerService.log(
          data.token,
          params.e_token,
          "Baecon registered for user - " + data.userId
        );
      }
      if (data.isExternalUrl === true) {
        if (data.runBeacon) {
          setTimeout(() => {
            sessionStore.removeItem("params");
            LoggerService.log(
              data.token,
              "",
              "Respondent redirected to external link " + data.url,
              data.isExternalUrl
            );
            windowLocation(data.url);
            // window.location.href = `${data.url}`;
          }, 500);
        } else {
          LoggerService.log(
            data.token,
            data.vendorToken ?? "",
            "Respondent redirected to external link ",
            data.isExternalUrl
          );
          if (data.redirectType === 3) {
            LoggerService.log(
              data.token,
              "Supplier redirect received",
              `${data.url}`
            );
            // await updateStatus(
            //   rObj.token,
            //   rObj.tokenId,
            //   StatusConstants.STATUS_SUPPLIER_REDIRECT_START,
            //   StatusConstants.SUB_STATUS_EXTERNAL_SUPPLIER_REDIRECT_DONE
            // );
            //TODO:: redirect via
            windowLocationRelayed(data.url,data.token);
          } else if (data.redirectType === 4) {
            LoggerService.log(
              data.token,
              "Client survey redirect received",
              `${data.url}`
            );
            
            windowLocationRelayed(data.url,data.token,"client");
          }
          sessionStore.removeItem("params");
        }
      } else {
        if (data.runBeacon) {
          setTimeout(() => {
            LoggerService.log(
              data.token,
              "",
              "Respondent navigated to internal link",
              `${data.url}?token=${data.token}`
            );
            navigate(`${PROFILING_ROUTE}?token=${data.token}`);
          }, 500);
        } else {
          LoggerService.log(
            data.token,
            data.vendorToken ?? "",
            "Respondent navigated to profiler",
            `${data.url}?token=${data.token}`
          );
          navigate(`${PROFILING_ROUTE}?token=${data.token}`);
        }
      }
    } catch (e) {
      LoggerService.log(
        "",
        params.e_token ?? "",
        "Error on landing page",
        JSON.stringify(e)
      );
      navigate(`/error`);
    }
  };

  useEffect(() => {
    if (paramActive) getStatus();

    // eslint-disable-next-line
  }, [paramActive, deviceType]);

  // useEffect(() => {
  //   if ((window).IPQ) {
  //     const fgn = (window).IPQ.Callback('YourCustomName');
  //     console.log(fgn)
  //   } else {
  //     console.warn('IPQ or Startup not loaded.');
  //   }
  // }, []);

  return (
    <>
      {beaconUrl ? (
        <img style={{ display: "none" }} src={beaconUrl}></img>
      ) : Loader ? (
        <div className="flex flex-col items-center justify-center h-screen bg-gray-200">
          <ClipLoader color="#f00" loading={true} size={80} />
        </div>
      ) : (
        <>
          <div className="flex  justify-center">
            <img
              src="https://img.icons8.com/bubbles/256/man-with-a-clock.png"
              alt=""
            />
          </div>
        </>
      )}
    </>
  );
};

export default Landing;
